/* eslint-disable no-magic-numbers */
import formRetentionIllustration from '@/assets/application-flow-skins/shared/form-retention-illustration.svg'
import productsRetentionIllustration from '@/assets/application-flow-skins/shared/products/retention-illustration.png'
import matchingIllustration from '@/assets/application-flow-skins/shared/matching/matching-illustration.png'
import blueMatchingShield from '@/assets/application-flow-skins/blue/matching/matching-shield.svg'
import blueRegisterCardHand from '@/assets/application-flow-skins/blue/register/register-card-hand.png'
import goldMatchingShield from '@/assets/application-flow-skins/gold/matching/matching-shield.svg'
import goldRegisterCardHand from '@/assets/application-flow-skins/gold/register/register-card-hand.png'
import greenMatchingShield from '@/assets/application-flow-skins/green/matching/matching-shield.svg'
import greenRegisterCardHand from '@/assets/application-flow-skins/green/register/register-card-hand.png'
import newPurpleMatchingShield from '@/assets/application-flow-skins/new-purple/matching/matching-shield.svg'
import newPurpleRegisterCardHand from '@/assets/application-flow-skins/new-purple/register/register-card-hand.png'
import orangeMatchingShield from '@/assets/application-flow-skins/orange/matching/matching-shield.svg'
import orangeRegisterCardHand from '@/assets/application-flow-skins/orange/register/register-card-hand.png'
import blueFormEditLimitIcon from '@/assets/application-flow-skins/blue/form/icon-edit-limit.svg'
import blueFormHeader from '@/assets/application-flow-skins/blue/form/form-header-bg.png'
import goldFormEditLimitIcon from '@/assets/application-flow-skins/gold/form/icon-edit-limit.svg'
import goldFormHeader from '@/assets/application-flow-skins/gold/form/form-header-bg.png'
import greenFormEditLimitIcon from '@/assets/application-flow-skins/green/form/icon-edit-limit.svg'
import greenFormHeader from '@/assets/application-flow-skins/green/form/form-header-bg.png'
import newPurpleFormEditLimitIcon from '@/assets/application-flow-skins/new-purple/form/icon-edit-limit.svg'
import newPurpleFormHeader from '@/assets/application-flow-skins/new-purple/form/form-header-bg.png'
import orangeFormEditLimitIcon from '@/assets/application-flow-skins/orange/form/icon-edit-limit.svg'
import orangeFormHeader from '@/assets/application-flow-skins/orange/form/form-header-bg.png'
import blueProductSelectedIcon from '@/assets/application-flow-skins/blue/products/icon-product-selected.svg'
import blueProductsIllustration from '@/assets/application-flow-skins/blue/products/products-illustration.png'
import goldProductSelectedIcon from '@/assets/application-flow-skins/gold/products/icon-product-selected.svg'
import goldProductsIllustration from '@/assets/application-flow-skins/gold/products/products-illustration.png'
import greenProductSelectedIcon from '@/assets/application-flow-skins/green/products/icon-product-selected.svg'
import greenProductsIllustration from '@/assets/application-flow-skins/green/products/products-illustration.png'
import newPurpleProductSelectedIcon from '@/assets/application-flow-skins/new-purple/products/icon-product-selected.svg'
import newPurpleProductsIllustration from '@/assets/application-flow-skins/new-purple/products/products-illustration.png'
import orangeProductSelectedIcon from '@/assets/application-flow-skins/orange/products/icon-product-selected.svg'
import orangeProductsIllustration from '@/assets/application-flow-skins/orange/products/products-illustration.png'

// 结果页资产
import newPurpleResultHeader from '@/assets/application-flow-skins/new-purple/result/result-header-bg.png'
import newPurpleResultMatchFailedHeader from '@/assets/application-flow-skins/new-purple/result/result-match-failed-header.png'
import newPurpleResultSuccessIllustration from '@/assets/application-flow-skins/new-purple/result/result-success-illustration.png'
import newPurpleResultApplicationFailedIllustration from '@/assets/application-flow-skins/new-purple/result/result-application-failed-illustration.png'
import newPurpleResultMatchFailedIllustration from '@/assets/application-flow-skins/new-purple/result/result-match-failed-illustration.png'
import newPurpleResultOfficialStatementIcon from '@/assets/application-flow-skins/new-purple/result/result-official-statement-icon.png'

import blueResultHeader from '@/assets/application-flow-skins/blue/result/result-header-bg.png'
import blueResultMatchFailedHeader from '@/assets/application-flow-skins/blue/result/result-match-failed-header.png'
import blueResultSuccessIllustration from '@/assets/application-flow-skins/blue/result/result-success-illustration.png'
import blueResultApplicationFailedIllustration from '@/assets/application-flow-skins/blue/result/result-application-failed-illustration.png'
import blueResultMatchFailedIllustration from '@/assets/application-flow-skins/blue/result/result-match-failed-illustration.png'
import blueResultOfficialStatementIcon from '@/assets/application-flow-skins/blue/result/result-official-statement-icon.png'

import greenResultHeader from '@/assets/application-flow-skins/green/result/result-header-bg.png'
import greenResultMatchFailedHeader from '@/assets/application-flow-skins/green/result/result-match-failed-header.png'
import greenResultSuccessIllustration from '@/assets/application-flow-skins/green/result/result-success-illustration.png'
import greenResultApplicationFailedIllustration from '@/assets/application-flow-skins/green/result/result-application-failed-illustration.png'
import greenResultMatchFailedIllustration from '@/assets/application-flow-skins/green/result/result-match-failed-illustration.png'
import greenResultOfficialStatementIcon from '@/assets/application-flow-skins/green/result/result-official-statement-icon.png'

import orangeResultHeader from '@/assets/application-flow-skins/orange/result/result-header-bg.png'
import orangeResultMatchFailedHeader from '@/assets/application-flow-skins/orange/result/result-match-failed-header.png'
import orangeResultSuccessIllustration from '@/assets/application-flow-skins/orange/result/result-success-illustration.png'
import orangeResultApplicationFailedIllustration from '@/assets/application-flow-skins/orange/result/result-application-failed-illustration.png'
import orangeResultMatchFailedIllustration from '@/assets/application-flow-skins/orange/result/result-match-failed-illustration.png'
import orangeResultOfficialStatementIcon from '@/assets/application-flow-skins/orange/result/result-official-statement-icon.png'

import goldResultHeader from '@/assets/application-flow-skins/gold/result/result-header-bg.png'
import goldResultMatchFailedHeader from '@/assets/application-flow-skins/gold/result/result-match-failed-header.png'
import goldResultSuccessIllustration from '@/assets/application-flow-skins/gold/result/result-success-illustration.png'
import goldResultApplicationFailedIllustration from '@/assets/application-flow-skins/gold/result/result-application-failed-illustration.png'
import goldResultMatchFailedIllustration from '@/assets/application-flow-skins/gold/result/result-match-failed-illustration.png'
import goldResultOfficialStatementIcon from '@/assets/application-flow-skins/gold/result/result-official-statement-icon.png'

// 下载页资产
import newPurpleDownloadHero from '@/assets/application-flow-skins/new-purple/download/download-hero.svg'
import newPurpleDownloadBadge from '@/assets/application-flow-skins/new-purple/download/download-badge.png'
import newPurpleDownloadBrandMark from '@/assets/application-flow-skins/new-purple/download/brand-mark.png'

import blueDownloadHeroBackground from '@/assets/application-flow-skins/blue/download/download-hero-background.png'
import blueDownloadHeroOverlay from '@/assets/application-flow-skins/blue/download/download-hero.png'
import blueDownloadBadge from '@/assets/application-flow-skins/blue/download/download-badge.png'
import blueDownloadBrandMark from '@/assets/application-flow-skins/blue/download/brand-mark.png'

import greenDownloadHeroBackground from '@/assets/application-flow-skins/green/download/download-hero-background.png'
import greenDownloadHeroOverlay from '@/assets/application-flow-skins/green/download/download-hero.png'
import greenDownloadBadge from '@/assets/application-flow-skins/green/download/download-badge.png'
import greenDownloadBrandMark from '@/assets/application-flow-skins/green/download/brand-mark.png'

import orangeDownloadHeroBackground from '@/assets/application-flow-skins/orange/download/download-hero-background.png'
import orangeDownloadHeroOverlay from '@/assets/application-flow-skins/orange/download/download-hero.png'
import orangeDownloadBadge from '@/assets/application-flow-skins/orange/download/download-badge.png'
import orangeDownloadBrandMark from '@/assets/application-flow-skins/orange/download/brand-mark.png'

import goldDownloadHeroBackground from '@/assets/application-flow-skins/gold/download/download-hero-background.png'
import goldDownloadHeroOverlay from '@/assets/application-flow-skins/gold/download/download-hero.png'
import goldDownloadBadge from '@/assets/application-flow-skins/gold/download/download-badge.png'
import goldDownloadBrandMark from '@/assets/application-flow-skins/gold/download/brand-mark.png'

import { ApplicationFlowTheme } from '../types'

type V2ChannelTemplate = 2 | 3 | 4 | 5 | 6

const THEME_BY_TEMPLATE: Record<V2ChannelTemplate, ApplicationFlowTheme> = {
  2: {
    name: 'new-purple',
    registerCardHand: newPurpleRegisterCardHand,
    matchingIllustration,
    matchingShield: newPurpleMatchingShield,
    formHeader: newPurpleFormHeader,
    formEditLimitIcon: newPurpleFormEditLimitIcon,
    formRetentionIllustration,
    productSelectedIcon: newPurpleProductSelectedIcon,
    productsIllustration: newPurpleProductsIllustration,
    productsRetentionIllustration,
    resultHeader: newPurpleResultHeader,
    resultMatchFailedHeader: newPurpleResultMatchFailedHeader,
    resultSuccessIllustration: newPurpleResultSuccessIllustration,
    resultApplicationFailedIllustration: newPurpleResultApplicationFailedIllustration,
    resultMatchFailedIllustration: newPurpleResultMatchFailedIllustration,
    resultOfficialStatementIcon: newPurpleResultOfficialStatementIcon,
    downloadHero: newPurpleDownloadHero,
    downloadBadge: newPurpleDownloadBadge,
    downloadBrandMark: newPurpleDownloadBrandMark,
  },
  3: {
    name: 'blue',
    registerCardHand: blueRegisterCardHand,
    matchingIllustration,
    matchingShield: blueMatchingShield,
    formHeader: blueFormHeader,
    formEditLimitIcon: blueFormEditLimitIcon,
    formRetentionIllustration,
    productSelectedIcon: blueProductSelectedIcon,
    productsIllustration: blueProductsIllustration,
    productsRetentionIllustration,
    resultHeader: blueResultHeader,
    resultMatchFailedHeader: blueResultMatchFailedHeader,
    resultSuccessIllustration: blueResultSuccessIllustration,
    resultApplicationFailedIllustration: blueResultApplicationFailedIllustration,
    resultMatchFailedIllustration: blueResultMatchFailedIllustration,
    resultOfficialStatementIcon: blueResultOfficialStatementIcon,
    downloadHero: blueDownloadHeroBackground,
    downloadHeroOverlay: blueDownloadHeroOverlay,
    downloadBadge: blueDownloadBadge,
    downloadBrandMark: blueDownloadBrandMark,
  },
  4: {
    name: 'green',
    registerCardHand: greenRegisterCardHand,
    matchingIllustration,
    matchingShield: greenMatchingShield,
    formHeader: greenFormHeader,
    formEditLimitIcon: greenFormEditLimitIcon,
    formRetentionIllustration,
    productSelectedIcon: greenProductSelectedIcon,
    productsIllustration: greenProductsIllustration,
    productsRetentionIllustration,
    resultHeader: greenResultHeader,
    resultMatchFailedHeader: greenResultMatchFailedHeader,
    resultSuccessIllustration: greenResultSuccessIllustration,
    resultApplicationFailedIllustration: greenResultApplicationFailedIllustration,
    resultMatchFailedIllustration: greenResultMatchFailedIllustration,
    resultOfficialStatementIcon: greenResultOfficialStatementIcon,
    downloadHero: greenDownloadHeroBackground,
    downloadHeroOverlay: greenDownloadHeroOverlay,
    downloadBadge: greenDownloadBadge,
    downloadBrandMark: greenDownloadBrandMark,
  },
  5: {
    name: 'orange',
    registerCardHand: orangeRegisterCardHand,
    matchingIllustration,
    matchingShield: orangeMatchingShield,
    formHeader: orangeFormHeader,
    formEditLimitIcon: orangeFormEditLimitIcon,
    formRetentionIllustration,
    productSelectedIcon: orangeProductSelectedIcon,
    productsIllustration: orangeProductsIllustration,
    productsRetentionIllustration,
    resultHeader: orangeResultHeader,
    resultMatchFailedHeader: orangeResultMatchFailedHeader,
    resultSuccessIllustration: orangeResultSuccessIllustration,
    resultApplicationFailedIllustration: orangeResultApplicationFailedIllustration,
    resultMatchFailedIllustration: orangeResultMatchFailedIllustration,
    resultOfficialStatementIcon: orangeResultOfficialStatementIcon,
    downloadHero: orangeDownloadHeroBackground,
    downloadHeroOverlay: orangeDownloadHeroOverlay,
    downloadBadge: orangeDownloadBadge,
    downloadBrandMark: orangeDownloadBrandMark,
  },
  6: {
    name: 'gold',
    registerCardHand: goldRegisterCardHand,
    matchingIllustration,
    matchingShield: goldMatchingShield,
    formHeader: goldFormHeader,
    formEditLimitIcon: goldFormEditLimitIcon,
    formRetentionIllustration,
    productSelectedIcon: goldProductSelectedIcon,
    productsIllustration: goldProductsIllustration,
    productsRetentionIllustration,
    resultHeader: goldResultHeader,
    resultMatchFailedHeader: goldResultMatchFailedHeader,
    resultSuccessIllustration: goldResultSuccessIllustration,
    resultApplicationFailedIllustration: goldResultApplicationFailedIllustration,
    resultMatchFailedIllustration: goldResultMatchFailedIllustration,
    resultOfficialStatementIcon: goldResultOfficialStatementIcon,
    downloadHero: goldDownloadHeroBackground,
    downloadHeroOverlay: goldDownloadHeroOverlay,
    downloadBadge: goldDownloadBadge,
    downloadBrandMark: goldDownloadBrandMark,
  },
}

const isV2ChannelTemplate = (value: unknown): value is V2ChannelTemplate => (
  value === 2 || value === 3 || value === 4 || value === 5 || value === 6
)

// 模板是唯一主题来源，品牌名只影响文案和标识，不能参与颜色推导。
export const getApplicationFlowTheme = (channelTemplate: unknown): ApplicationFlowTheme | null => (
  isV2ChannelTemplate(channelTemplate) ? THEME_BY_TEMPLATE[channelTemplate] : null
)
